import app from './Vue/app';
import { defineAsyncComponent } from 'vue';
import Water from './Vue/Components/water.vue';
import BottleLoader from './Vue/Components/Product/BottleLoader.vue';
import TextCurve from './Vue/Components/Product/TextCurve.vue';
import ScrollController from './Vue/Components/Product/ScrollController.vue';

const Carousel = defineAsyncComponent(() => import('./Vue/Components/Carousel.vue'));
const VideoPlayer = defineAsyncComponent(() => import('./Vue/Components/VideoPlayer.vue'));

app.component('Water', Water);
app.component('BottleLoader', BottleLoader);
app.component('TextCurve', TextCurve);
app.component('Carousel', Carousel);
app.component('VideoPlayer', VideoPlayer);
app.component('ScrollController', ScrollController);
